export default __webpack_public_path__ + "static/media/boilblood.0d89f95e.png";